(function () {
  if (window.KinokoNavVisitTracker) return;
  window.KinokoNavVisitTracker = true;

  const LOCAL_NAV_KEY = 'kinoko_nav_log';
  const LOCAL_LANDING_KEY = 'kinoko_landing_url';
  const CHECKOUT_RETURN_PATH_KEY = 'kinoko_pre_checkout_path';
  const MAX_LOG_ITEMS = 30;

  function parseJson(value, fallback) {
    try {
      return JSON.parse(value || '');
    } catch {
      return fallback;
    }
  }

  function logTime() {
    return new Date().toLocaleString('de-DE', {
      timeZone: 'Europe/Berlin',
      hour12: false
    });
  }

  function currentUrlForNav() {
    return window.location.pathname || '/';
  }

  function getLandingUrl() {
    const currentUrl = window.location.href;

    try {
      let landing = localStorage.getItem(LOCAL_LANDING_KEY);

      if (!landing) {
        landing = currentUrl;
        localStorage.setItem(LOCAL_LANDING_KEY, landing);
      }

      return landing;
    } catch {
      return currentUrl;
    }
  }

  function getNavLog() {
    try {
      const log = parseJson(localStorage.getItem(LOCAL_NAV_KEY), []);
      return Array.isArray(log) ? log : [];
    } catch {
      return [];
    }
  }

  function saveNavLog(log) {
    try {
      localStorage.setItem(
        LOCAL_NAV_KEY,
        JSON.stringify(log.slice(-MAX_LOG_ITEMS))
      );
    } catch {}
  }

  function getPreCheckoutPath() {
    try {
      return sessionStorage.getItem(CHECKOUT_RETURN_PATH_KEY) || '';
    } catch {
      return '';
    }
  }

  function normalizeReturnFromCheckout(event, navLog) {
    const lastEvent = navLog[navLog.length - 1];
    if (!lastEvent) return event;

    const preCheckoutPath = getPreCheckoutPath();

    if (
      event.url === '/' &&
      lastEvent.url === '/checkout' &&
      preCheckoutPath &&
      preCheckoutPath !== '/'
    ) {
      return {
        url: preCheckoutPath,
        time: event.time
      };
    }

    return event;
  }

  function trackPageVisitLocally() {
    getLandingUrl();

    let event = {
      url: currentUrlForNav(),
      time: logTime()
    };

    const navLog = getNavLog();

    event = normalizeReturnFromCheckout(event, navLog);

    const lastEvent = navLog[navLog.length - 1];

    if (lastEvent && lastEvent.url === event.url) {
      lastEvent.time = event.time;
      saveNavLog(navLog);
      return;
    }

    saveNavLog(navLog.concat(event));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackPageVisitLocally, { once: true });
  } else {
    trackPageVisitLocally();
  }
})();